import { render, staticRenderFns } from "./ExerciseTemplate.vue?vue&type=template&id=994b4264&"
import script from "./ExerciseTemplate.vue?vue&type=script&lang=js&"
export * from "./ExerciseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports